import React, { useState } from 'react';
import { XIcon, RocketIcon } from 'lucide-react';
export function AnnouncementBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="bg-brand-black text-white px-4 py-3 relative flex items-center justify-center z-50" data-id="element-81" data-mp="jtk1t94iugih">
      <div className="flex items-center space-x-2 text-sm md:text-base font-medium" data-id="element-82" data-mp="evsc8lrcn6hg">
        <RocketIcon className="h-4 w-4 text-red-500" data-id="element-83" data-mp="9vnr2ifhxnkw" />
        <span data-id="element-84" data-mp="9x8qomgo3wpm">Free 60-Minute Strategy Session — Book Now</span>
      </div>
      <button onClick={() => setIsVisible(false)} className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white transition-colors" aria-label="Close announcement" data-id="element-85" data-mp="5t9euh6c1m2l">
        <XIcon className="h-5 w-5" data-id="element-86" data-mp="3s33lj1djvc8e" />
      </button>
    </div>;
}